export default {"src":"/_next/static/media/reactIcon.5438c05d.svg","height":32,"width":32};